/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'play': {
    width: 26,
    height: 26,
    viewBox: '0 0 26 26',
    data: '<g _fill="#004CD0" fill-rule="evenodd"><g fill-rule="nonzero"><path pid="0" d="M17.563 11.25l-6.142-4.415c-.607-.435-1.386-.607-1.993-.257-.607.257-.95.95-.95 1.729v9.342c0 .779.343 1.386.95 1.729.258.086.522.171.779.171.435 0 .864-.171 1.214-.52l6.142-4.415c.607-.435.95-1.036.95-1.729 0-.6-.342-1.207-.95-1.636zm-1.035 2.071l-6.143 4.414c-.086 0-.172.086-.172.086V8.307v-.172c.086 0 .086.086.258.172l6.142 4.414c.086 0 .172.171.172.257s-.086.257-.257.343z"/><path pid="1" d="M12.978 0A12.96 12.96 0 000 12.978a12.956 12.956 0 0012.978 12.978 12.956 12.956 0 0012.978-12.978A12.96 12.96 0 0012.978 0zm0 24.22A11.218 11.218 0 011.735 12.979 11.218 11.218 0 0112.978 1.735a11.218 11.218 0 0111.243 11.243A11.218 11.218 0 0112.978 24.22z"/></g><path pid="2" d="M9.213 7.135v12l8-5.973z"/></g>'
  }
})
